module.exports = __webpack_public_path__ + "static/turquia-005.thumb-c593f3cee64af9be137c909cdd663f58.jpg";